var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-exercise-footer',[_c(_vm.footerComponent,{tag:"component",attrs:{"next-exercise":_vm.nextExercise},on:{"end-exercise":_vm.handleEndExercise,"next-exercise":_vm.handleNextExercise}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }